<template>
  <div>
    <div class="header_mobile">
      <div class="header_menu">
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#ffffff"
          active-text-color="#da261d"
          :defaultActive="activeNum"
        >
          <el-menu-item index="1">
            <i class="iconfont iconshouye"></i>
            <span slot="title">
              <router-link to="/index">首页 </router-link>
            </span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="iconfont iconguanyuwomenicon"></i>
            <span slot="title">
              <router-link to="/aboutUs">关于我们 </router-link>
            </span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="iconfont iconxinwen"></i>
            <span slot="title">
              <router-link to="/newsMobile">媒体新闻 </router-link>
            </span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="iconfont iconqiyefuwudongtai"></i>
            <router-link to="/enterprise">企业服务 </router-link>
          </el-menu-item>
          <el-menu-item index="6">
            <i class="iconfont iconlianxiwomen"></i>
            <router-link to="/contactUs">联系我们 </router-link>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNum: "",
    };
  },
  created() {
    // console.log(window.location.href);
    var url = window.location.href.split("#/")[1];
    // console.log(url);
    switch (url) {
      case "index":
        this.activeNum = "1";
        break;
      case "aboutUs":
        this.activeNum = "2";
        // console.log(this.activeNum);
        break;
      case "newMobile":
        this.activeNum = "3";
        break;
      case "enterprise":
        this.activeNum = "4";
        break;
      case "contactUs":
        this.activeNum = "6";
        break;
    }
  },
  methods: {
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .header_mobile {
    // height: 100vh;
    height: 100%;
    width: 40%;
    display: block;
    position: absolute;
    .header_menu {
      height: 100%;
      ul.el-menu-vertical-demo.el-menu {
        height: 100%;
        width: 150px;
      }
      li.el-menu-item {
        border-bottom: 1px solid #f5f5f5;
      }
      .iconfont {
        margin-right: 10px;
      }
    }
  }
}
</style>
